import * as types from './mutation_types'

export default {
  [types.EXSBWAREHOUSEITEM_SHOW_RESET] (state) {
    Object.assign(state, {
      error: '',
      isLoading: false,
      retrieved: null
    })
  },

  [types.EXSBWAREHOUSEITEM_SHOW_SET_ERROR] (state, error) {
    Object.assign(state, { error })
  },

  [types.EXSBWAREHOUSEITEM_SHOW_SET_RETRIEVED] (state, retrieved) {
    Object.assign(state, { retrieved })
  },

  [types.EXSBWAREHOUSEITEM_SHOW_TOGGLE_LOADING] (state) {
    Object.assign(state, { isLoading: !state.isLoading })
  }

}
